import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/service/common.service';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  otpForm!: FormGroup
  passwordForm!: FormGroup
  submitted: boolean = false
  private renderer!: Renderer2
  resendCountdown: number = 60;
  resendTimer: any;
  timeRemaining_percent!: number;
  timer!: number;
  remainingTime!: number;
  intervalId: any;
  showResend: boolean = false;
  idInvalid: boolean = false;
  showResendButton: boolean = false;
  @ViewChild('otpInput') otpInput!: ElementRef;
  otp: string = '';
  url: string = '';
  uniqueCode: string = '';
  constructor(private fb: FormBuilder,
    private dialog: MatDialog,
    private loader: LoaderService,
    private restService: RestService,
    private translate: TranslateService,
    private commonService: CommonService, private route: ActivatedRoute, private router: Router,  private cookieService: CookieService,) { }

  ngOnInit(): void {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.required]],
      otp0: ['', [Validators.required]],
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]],
    })
    this.passwordForm = this.fb.group({
      newpassword: ['', [Validators.required, Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=])\S{8,20}$/)]],
      connewpassword: ['', [Validators.required, Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=])\S{8,20}$/)]]
    },
      {
        validator: this.MustMatch('newpassword', 'connewpassword')

      });
    for (let i = 0; i < 6; i++) {
      this.otpForm.addControl('otp' + i, new FormControl('', Validators.required))
    }
    this.otpForm.valueChanges.subscribe(value => {
      this.submitted = false;
    })
    this.route.url.subscribe(url => {
      this.url = url[0].path;
    });
    this.route.params.subscribe((params) => {
      this.uniqueCode = params['uniqueCode']
    })
  
    this.startResendTimer()
  }
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  setFocusOnOTPInput() {
    setTimeout(() => {
      if (this.otpInput?.nativeElement) {
        this.renderer.selectRootElement(this.otpInput.nativeElement).focus();
      }
    }, 100);
  }
  get control() {
    return this.otpForm.controls;
  }
  onInputChange(event: Event, forWhat: string) {
    this.otpForm.controls[forWhat].setValue((event.target as HTMLInputElement).value.replace(/\D/g, ''))
  }

  onOtpInput(index: number) {
    const nextIndex = index + 1;
    this.otp = this.otp + this.otpForm.controls['otp' + index].value;
    if (nextIndex < 6 && this.otpForm.controls['otp' + index].value) {
      const input = <HTMLInputElement>document.getElementById('otp' + nextIndex);
      input.focus();
    }
  }

  numberOnly(event: any, index: number) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onBackspaceKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (index >= 0) {
        this.otpForm.controls['otp' + index].setValue(''); // Delete the previous item in the OTP array
        if (index > 0) {
          this.otpForm.controls['otp' + (index - 1)].setValue('');
        }
        const previousInputId = 'otp' + (index - 1);
        const previousInputElement = document.getElementById(previousInputId) as HTMLInputElement;
        if (previousInputElement) {
          previousInputElement.focus(); // Focus the previous input box
        }
      }
    }
  }

  getOtp() {
    let otp = '';
    for (let i = 0; i < 6; i++) {
      otp += this.otpForm.controls['otp' + i].value;
    }
    this.otpForm.controls['otp'].setValue(otp);
  }

  startResendTimer() {
    this.resendCountdown = 60;
    this.timer = this.resendCountdown;
    this.remainingTime = this.timer;
    this.timeRemaining_percent = (this.remainingTime / this.timer) * 100
    this.intervalId = setInterval(() => {
      this.remainingTime--;
      this.timeRemaining_percent = (this.remainingTime / this.timer) * 100
      if (this.remainingTime <= 0) {
        this.stopCountdownTimer();
        this.showResendButton = true;
      }
    }, 1000);
  }
  stopCountdownTimer() {
    clearInterval(this.intervalId);
  }
  resendOTP() {
    this.showResendButton = false;
    this.otpForm.reset('')
    this.sendResetPwdOTP()
  }
  validateOtp() {
    this.loader.show()
    this.getOtp();
    this.submitted = true
    if (this.otpForm.valid) {
      let url = 'api/digital/core/ResetPassword/ValidateResetPasswordOTP'
      let otpParams = {
        "uniqueCode": this.uniqueCode,
        "otp": this.otpForm.get('otp')?.value
      }
      this.restService.postUATData(otpParams, url).subscribe({
        next: (data) => {
          if (data.rcode === 200) {
            this.router.navigate(['/auth/reset-password/' + this.uniqueCode]);
            this.loader.hide();
          }
          else {
            this.loader.hide();
            let a = data.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
            });
            dialogRef.afterClosed().subscribe();
          }
        },
        error: (error) => {
          if (error.error.rcode != 401 && error.error.rcode != 403
            && error.error.rcode != 404 && error.error.rcode != 500) {
            this.loader.hide();
            let a = error.error.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: { error: true, trnID: error.error.trnID, errorMessage: err }
            });
            dialogRef.afterClosed().subscribe();
          }
        },
      });
    }
  }
  updateResetPwd() {
    this.loader.show()
    if (this.passwordForm.valid) {
      let url = 'api/digital/core/ResetPassword/UpdateResetPassword'
      let otpParams = {
        "uniqueCode": this.uniqueCode,
        "newPassword": this.passwordForm.get('newpassword')?.value
      }
      this.loader.show()
      this.restService.postUATData(otpParams, url).subscribe({
        next: (data) => {
          if (data.rcode === 200) {
            this.loader.hide();
            let _dialogRef = this.dialog.open(MatDialogComponent, {
              width: '50VW',
              disableClose: true,
              data: {
                success: true,
                trnID: data.transactionRef,
                errorMessage: "Your password has been successfully reset!."
              }
            })
            _dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.url = this.cookieService.get('redirect_url');
                if (this.url) {
                  const redirectUrl = new URL(this.url);
                const baseUrl = `${redirectUrl.protocol}//${redirectUrl.hostname}${redirectUrl.port ? ':' + redirectUrl.port : ''}`;
                window.location.href = baseUrl; 
                }
              }
            })
          }
          else {
            this.loader.hide();
            let a = data.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
            });
            dialogRef.afterClosed().subscribe();
          }
        },
        error: (error) => {
          if (error.error.rcode != 401 && error.error.rcode != 403
            && error.error.rcode != 404 && error.error.rcode != 500) {
            this.loader.hide();
            let a = error.error.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: { error: true, trnID: error.error.trnID, errorMessage: err }
            });
            dialogRef.afterClosed().subscribe();
          }
        },
      });
    }
  }
  sendResetPwdOTP() {
    this.loader.show()
    let url = 'api/digital/core/ResetPassword/SendResetPasswordOTP'
    let params = {
      "uniqueCode": this.uniqueCode
    }
    this.restService.postUATData(params, url).subscribe({
      next: (data) => {
        if (data.rcode === 200) {
          this.loader.hide();
          this.startResendTimer()
        }
        else {
          this.loader.hide();
          let a = data.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
      error: (error) => {
        if (error.error.rcode != 401 && error.error.rcode != 403
          && error.error.rcode != 404 && error.error.rcode != 500) {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: error.error.trnID, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
    });
  }
}
